import { useRecoilCallback } from 'recoil';
import { API_URLS } from 'settings/api';
import { fetchSelector } from 'common/state/common';
import { UserDetailsResponse } from 'common/types/account';
import { useRefetchAccountDetails } from 'common/hooks/account';
import { useRollbar } from '@rollbar/react';
import { LogArgument } from 'rollbar';
import { useShowToast } from 'common/hooks/notification';
import { useTranslation } from 'react-i18next';

export const usePreferences = (): ((data: unknown) => Promise<void>) => {
  const rollbar = useRollbar();
  const showToast = useShowToast();
  const { t } = useTranslation();

  const { refetchAccountDetails } = useRefetchAccountDetails();
  return useRecoilCallback(
    ({ snapshot }) =>
      async data => {
        const { fetchPatch } = await snapshot.getPromise(fetchSelector);
        try {
          const userDetails = await fetchPatch<UserDetailsResponse>(API_URLS.PROFILE, {
            ui_preferences: data,
          });
          refetchAccountDetails(userDetails);
          showToast({ message: t('appearance.colorUpdatedSuccess'), status: 'success' });
        } catch (e) {
          rollbar.error('usePreferences error', e as LogArgument);
          showToast({ message: t('appearance.colorUpdateError'), status: 'error' });
        }
      },
    [refetchAccountDetails],
  );
};
